import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryStatus extends BaseModelAPI {
	static entity = 'deliverystatus';
	static entityName = 'deliverystatus';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}